import { Dispatch, Middleware, MiddlewareAPI } from 'redux';

import { RootState } from '../index';
import { interpalsApiUrl } from 'api';

import { onMessage } from './websocketEvents';

const WEBSOCKET_URL = interpalsApiUrl.replace('http', 'ws') + '/ws?token=';

let socket: WebSocket | null = null;
let retryCount = 0;

const connect = (store: MiddlewareAPI<Dispatch, RootState>) => {
    const url = store.getState().auth.token ? WEBSOCKET_URL + store.getState().auth.token : null;

    if (url === null) return;

    socket = new WebSocket(url);

    socket.onopen = () => {
        store.dispatch({ type: 'WS_OPEN' });

        retryCount = 0;
    };

    socket.onclose = (event) => {
        console.log('[WebSocket] OnClose: reason:', event.reason, 'code: ', event.code);
        store.dispatch({ type: 'WS_CLOSE' });

        const retryTimeout = Math.pow(2, Math.min(retryCount, 8));
        retryCount++;

        console.log('[WebSocket] Retry in ', retryTimeout);

        setTimeout(() => {
            connect(store);
        }, retryTimeout * 1000);
    };

    socket.onmessage = (event) => onMessage(event, store);
    socket.onerror = (error) => store.dispatch({ type: 'WS_ERROR', error });
    socket.onerror = (event) => {
        // Error (event) is not serializable, so extract relevant information
        const errorDetails = {
            type: event.type,
            isTrusted: event.isTrusted,
            timeStamp: event.timeStamp,
            url: (event?.currentTarget as WebSocket).url,
        };

        // Dispatch an action with the extracted information
        store.dispatch({
            type: 'WS_ERROR',
            error: errorDetails,
        });
    };
};

export const webSocket: Middleware = (store) => (next) => (action) => {
    switch (action.type) {
        case 'WS_SENDMESSAGE':
            if (socket !== null) {
                socket.send(JSON.stringify(action.payload));
            }

            break;
        case 'WS_CONNECT':
            if (socket !== null) {
                store.dispatch({
                    type: 'WS_CLOSE',
                });

                socket.close();
                socket = null;
            }

            connect(store);
            break;
        case 'WS_DISCONNECT':
            if (socket !== null) {
                store.dispatch({
                    type: 'WS_CLOSE',
                });

                // Disable reconnect when we close connection, because it's an expected close
                socket.onclose = null;
                socket.close();
            }

            socket = null;
            break;
        default:
            return next(action);
    }
};
